import Vue from 'vue';
import {getId} from "@/api/common";
import commAxios from "../api/commAxios";
import wx from "weixin-js-sdk";

// 根据身份证号获取出生日期、年龄、性别
export function getIDData(identity) {
    return commAxios.post('account/api/account/brithdate?identity=' + identity);
}

/**
 * 快速校验身份证号是否合法, 不提供错误提示
 * @param identify
 * @returns {boolean} 合法返回 true, 非法返回false
 */
export function checkIdentify(identify) {
    return /(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}$)|(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/.test(identify);
}

export const getTreeDataById=(tree,list)=>{
    if(Array.isArray(tree)){
        tree.map((item)=>{
            // console.log('--item',item);
            if(list[item.id]){
                list[item.id].push(item.name);
            }else{
                list[item.id]= [item.name];
            }
            if(Array.isArray(item.children)&&item.children.length>0){
                getTreeDataById(item.children,list);
            }
        });
    }
}

export const extend = (destination, source) => {
    const toStr = Object.prototype.toString,
        strobject = toStr.call({}),
        strarray = toStr.call([]);
    for (const property in source) {
        if (source[property] && strobject === toStr.call(source[property])) {
            destination[property] = (toStr.call(source[property]) === strarray) ? [] : {};
            extend(destination[property], source[property]);
        } else {
            destination[property] = source[property];
        }
    }
    return destination;
}

export const transformDdl = (data) => {
    return data.map(i => Object({value: i.code, text: i.name}))
}


/**
 * @param {date} 标准时间格式:Fri Nov 17 2017 09:26:23 GMT+0800 (中国标准时间)
 * @param {type} 类型
 *   type == 1 ---> "yyyy-mm-dd hh:MM:ss.fff"
 *   type == 2 ---> "yyyymmddhhMMss"
 *   type == '' ---> "yyyy-mm-dd hh:MM:ss"
 */
export const formatDate = (date, type) => {
    let year = date.getFullYear();//年
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;//月
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();//日
    let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();//时
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();//分
    let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();//秒
    let milliseconds = date.getMilliseconds() < 10 ? "0" + date.getMilliseconds() : date.getMilliseconds() //毫秒
    if (type == 1) {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds + "." + milliseconds;
    } else if (type == 2) {
        return year + "" + month + "" + day + "" + hour + "" + minutes + "" + seconds;
    } else if (type == 3) {
        return year + "-" + month + "-" + day;
    } else {
        return year + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" + seconds;
    }
}

/**
 * 创建一个id
 * @returns {Promise}
 * */
export const createId = () => {
    const myId = (time) => {
        return new Promise((resolve, reject) => {
            time++;
            if (time > 3) {
                Vue.prototype.$notify('系统错误，请重试!');
                reject();
            } else {
                getId().then((res) => {
                    resolve(res.data)
                }).catch(() => {
                    return myId(time);
                })
            }
        })
    };
    return myId(0);
}

/**
 * 自定义forEach方法
 */
export const customForEach = async (arr, callback) => {
    const length = arr.length;
    const O = Object(arr);
    let k = 0;
    while (k < length) {
        if (k in O) {
            console.log('doing foreach...');
            const kValue = O[k];
            await callback(kValue, k, O);
        }
        k++;
    }
}

/**
 * 下载文件
 * @param {String} url 请求地址
 * @returns {void}
 * */
export const downloadFile = (url) => {
    wx.miniProgram.navigateTo({
        url: url
    })
}

/**
 * 格式化金钱
 * @param {String} num 金额数值
 * @returns {String} 格式化之后的金额，千分位加上,
 * */
export const formatMoney = (num) => {
    let _formatMoney = String(num).replace(/\,|\，/g, '')
    _formatMoney = _formatMoney.toString().replace(/\d+/, function (n) { // 先提取整数部分
        return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
            return $1 + ",";
        });
    });
    return _formatMoney;
}
